import type { FC } from 'react';
import { Sticker } from '@genially/public-web-components';
import { parseMedia } from 'core/infrastructure/parseMedia';

export const ParagraphSticker: FC<any> = ({ media, position }) => {
  return <Sticker media={parseMedia(media)} position={position} />;
};
